/** 提交订单和去支付判定逻辑 */
import { TLang } from '@/utils/lang';

export const goPayHandle = () => {
  /**
   * TODO: 输入和设置密码逻辑梳理：
   ** 判断是否已有密码
   *** 有，输入密码
   **** 没有，设置密码，先判断是否已绑手机号码
   ***** 已绑，输入验证码，设置密码
   ***** 未绑，先绑定手机号码，输入验证码，设置密码
   *
   */
  const isHasPw = true;
  const isBindPhone = true;

  switch (true) {
    // 有输入密码
    case isHasPw:
      console.log('....has');
      break;
    // 设置密码，已绑定手机号
    case !isHasPw && isBindPhone:
      break;
    // 设置密码，未绑定手机号
    case !isHasPw && !isBindPhone:
      break;
    default:
      break;
  }
};

/** Step不同，展示不同标题文案 */
export const STEP_TITLE = [
  '', // 占位符
  TLang('绑定您的手机号', 'home', false, false, null),
  TLang('请输入短信验证码', 'home', false, false, null),
  TLang('请设置4位支付密码', 'home', false, false, null),
  TLang('请输入支付密码', 'home', false, false, null),
  TLang('请确认支付密码', 'home', false, false, null)
];

/** Step不同，配置不同输入长度不同 */
export const STEP_LIMIT = ['', 11, 6, 4, 4, 4];

/** Step，校验文案 */
export const STEP_WARN_TEXT = [
  '', // 0
  TLang('该手机号已被绑定', 'home', false, false, null), // 1
  TLang('验证码不正确，请重新输入', 'home', false, false, null), // 2
  TLang('输入的密码4位数字不能相同或连接', 'home', false, false, null), // 3
  (limit) => `

  ${ReplaceText(
    'X',
    limit,
    TLang('密码不正确，剩余X次机会', 'home', false, false, null),
    false
  )}`, // 4
  '' // 5
];
